import type { Scene, SceneTimelineUpdateItem } from '../types';
import apiRequest from './apiRequest';

export type SceneReferenceUpdateRequest = {
  objectID?: string;
  stitchFromIndex?: number;
  timeline: SceneTimelineUpdateItem[];
};

// Returned (202) when swapping to an mjcf robot: the retarget runs async on forge and the
// caller polls /forge-retargets/{jobID} for the finished scene.
export type ForgeRetargetPending = {
  jobID: string;
  status: string;
};

export default async function postExternalSceneReference(
  apiKey: string,
  sceneID: string,
  referenceName: string,
  request: SceneReferenceUpdateRequest,
) {
  return await apiRequest<Scene | ForgeRetargetPending>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/${encodeURIComponent(referenceName)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(request),
    },
  );
}
